<template>
  <div class="lp-child-base basic-result" :style="styles">
    <block-title :target-info="targetInfo" :color-scheme="colorScheme" />
    <block-fortune-result :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" />
    <!-- <block-sns-share :target-info="targetInfo" :color-scheme="colorScheme" :result-share-words="resultShareWords" :result-share-url="resultShareUrl" :lp-id="lpId"/> -->
    <!-- <block-mokuji :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" /> -->
    <block-lead-menu :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" />
    <block-about-type :lp-id="lpId" :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" />
    <!-- <block-sns-share :target-info="targetInfo" :color-scheme="colorScheme" :result-share-words="resultShareWords" :result-share-url="resultShareUrl" :lp-id="lpId"/> -->
    <!-- <block-lead-subsc :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->
    <!-- <block-advice :target-info="targetInfo" :color-scheme="colorScheme" :result-data="resultData" /> -->
    <!-- <block-title2 :target-info="targetInfo" :color-scheme="colorScheme" /> -->
    <!-- <block-another-fotune-num :fortune-num="+resultData.text5" /> -->
    <block-another-fotune-num2 :fortune-num="+resultData.text5" :second-fortune-num-img="resultData.image2" :lp-id="lpId" :target-info="targetInfo" :color-scheme="colorScheme" :subsc-url="subscUrl"/>
    <!-- <block-link-input :lp-id="lpId" /> -->
    <block-uranai-tv-desc
      :lp-id="lpId"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :preview-result-list="previewResultList"
      :subsc-url="subscUrl"
      :test-data="testData"
    />


    <!-- <block-fortune-input :target-info="targetInfo" :color-scheme="colorScheme" :action="action" :method="method" :token="token" :lp-id="lpId" pageLabel="basicresult" /> -->
    <!-- <block-faq :color-scheme="colorScheme" :subsc-url="subscUrl" /> -->

    <!--
    <block-uranai-tv-short
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :subsc-url="subscUrl"
      :lp-id="lpId"
      page="basicresult"
      :is-individualed="true"
    />
    -->

    <!--
    <block-menus
      v-if="menusList.length"
      :lp-id="lpId"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :menu-list="menusList"
      :tab-list="menusTabList"
      :ga-event-categ="`LP${lpId}basicresult-paid-content-button`"
      page="basicresult"
    />
    -->

    <!-- <line-campaign-message :target-info="targetInfo" :color-scheme="colorScheme"/> -->

    <!--
    <block-banner
      v-if="showBanner"
      banner-pos="1"
      :ga-event-categ="`LP${lpId}basicresult-LINE-campaign-banner`"
      :lp-id="lpId"
      :campaign="bannerType"
      :target-info="targetInfo"
      :color-scheme="colorScheme"
      :has-caption="true"
    />
    -->
  </div>
</template>

<script>
import BlockTitle from '@/utvStore/components/recommend/lp/blocks/BlockTitle'
import BlockFortuneResult from './blocks/BlockFortuneResult'
import BlockSnsShare from '@/utvStore/components/recommend/lp/blocks/BlockSnsShare'
// import BlockMokuji from './blocks/BlockMokuji'
import BlockLeadMenu from './blocks/BlockLeadMenu'
import BlockMenus from '@/utvStore/components/recommend/lp/blocks/BlockMenus'
import BlockAboutType from './blocks/BlockAboutType'
import BlockLeadSubsc from '@/utvStore/components/recommend/lp/blocks/BlockLeadSubsc'
// import BlockAdvice from './blocks/BlockAdvice'
import BlockTitle2 from '@/utvStore/components/recommend/lp/blocks/BlockTitle2'
import BlockFortuneInput from './blocks/BlockFortuneInput'
import BlockFaq from '@/utvStore/components/recommend/lp/blocks/BlockFaq'
import BlockBanner from '@/utvStore/components/recommend/lp/blocks/BlockBanner'
import LineCampaignMessage from '@/utvStore/components/recommend/lp/partials/LineCampaignMessage'
import BlockUranaiTvShort from '@/utvStore/components/recommend/lp/blocks/BlockUranaiTvShort'
import BlockUranaiTvDesc from '@/utvStore/components/recommend/lp/counselor/houen/blocks/BlockUranaiTvDesc'
import BlockLinkInput from './blocks/BlockLinkInput'
import BlockAnotherFotuneNum from './blocks/BlockAnotherFotuneNum'
import BlockAnotherFotuneNum2 from './blocks/BlockAnotherFotuneNum2'
import PATTERN_DATA from './testData'


export default {
  name: 'BasicResult',
  components: {
    BlockTitle,
    BlockFortuneResult,
    BlockSnsShare,
    // BlockMokuji,
    BlockLeadMenu,
    BlockMenus,
    BlockAboutType,
    BlockLeadSubsc,
    // BlockAdvice,
    BlockTitle2,
    BlockFortuneInput,
    BlockFaq,
    BlockBanner,
    LineCampaignMessage,
    BlockUranaiTvShort,
    BlockUranaiTvDesc,
    BlockLinkInput,
    BlockAnotherFotuneNum,
    BlockAnotherFotuneNum2,
  },
  props: {
    lpId: {
      type: Number,
      default: 1,
    },
    menusList: {
      type: Array,
      default(){
        return []
      }
    },
    menusTabList: {
      type: Array,
      default(){
        return []
      }
    },
    targetInfo: {
      type: Object,
      default(){
        return {}
      }
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    resultData: Object,
    token: {
      type: String,
      default: '',
    },
    subscUrl: String,
    resultShareWords: {
      type: String,
      default: '',
    },
    bannerType: {
      type: String,
      default: 'LINE',
    },
    previewResultList: {
      type: Array,
      default: null,
    },
    testCase: String,
  },
  data(){
    return {
      action: `/recommend/lp/${this.lpId}/basic/action`,
      method: 'post'
    }
  },
  computed:{
    resultDataMod(){
      return {
        ...this.resultData,
        image2: 'hoge/img.png',
        profileName: 'aaa'
      }

    },
    resultShareUrl(){
      return !!location.href ? location.href : ''
    },
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
    showBanner() {
      return true
    },
    testData(){
      const testLetter = /^[AB]$/.test(this.testCase) ? this.testCase : 'A'
      const tgtData = PATTERN_DATA[`pattern${testLetter}`]
      return {
        testLetter: testLetter,
        ...tgtData,
      }
    }
  },
  mounted(){
    //※できるかぎりこの場でactionとcategoryはわかるようにしておいてください（何に対して何をやっているがわかればいいです）
    window.gtag('event', 'imp', {
      'event_category': `LP${this.lpId}basicresult-ABtest-imp`,
      'event_label': this.testData.testLetter
    })
  },
}</script>

<style scoped lang="scss">
@import "../../../../../../../sass/commons/commonVariables.scss";
$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);

.btn-base {
  width: 100%;
  padding: 20px;
}
.lp-child-base {
  color: #32373F;
  .block-title,
  .block-fortune-result {
    background: #4D89C4;
  }
  .block-sns-share{
    background: #EDED67;
  }
  .block-another-fortune-num {
    background: #fff;
  }
  .block-title2,
  .block-fortune-input {
    background: #F9F5ED;
  }
  .block-menu-base {
    padding-bottom: 22px;
    background: $l_col_mess_bg;
  }
  .line-campaign-message {
    background: #fff;
  }
  .block-banner {
    padding: 8px 20px 40px;
    margin-bottom: 48px;
    background: $l_col_mess_bg;
  }
  /deep/ {
    .block-title__sub,
    .block-title__title {
      color: #fff;
    }
    .block-lead-menu__comment {
      background: #EDED67;
      &::after {
        border-right-color: #EDED67;
      }
    }
  }
  /deep/ .block-uranaitv-base{
    background: #f5f5f5;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/houen/BasicResult.vue